module.exports = __webpack_public_path__ + "media/images/emblems/Wettswil_am_Albis-blazon-b5ed7fb3e5444a3f488a2d23af9afdef.svg";